<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { RouterView } from 'vue-router'
  import { OptionsSnackbar } from '@haskoning/vue-component-library'
  import AppHeader from '@/components/app/AppHeader.vue'
  import { SpeckleSnackbar } from '@haskoning/vue-speckle'
  import LoadingNotice from './components/app/LoadingNotice.vue'

  const authStore = inject('useAuthStore')
  const authorizationStore = useAuthorizationStore()
  const { user, isInitDone } = storeToRefs(authStore)

  onMounted(async () => {
    if (user.value) authorizationStore.setCurrentItem([user.value.role])
  })
</script>

<template>
  <v-app v-if="isInitDone">
    <AppHeader />
    <v-main>
      <RouterView />
    </v-main>
    <OptionsSnackbar :excluded-http-methods="['GET', 'OPTIONS']"></OptionsSnackbar>
    <SpeckleSnackbar></SpeckleSnackbar>
  </v-app>
  <LoadingNotice v-else :app-name="'GEOProfile'"></LoadingNotice>
</template>
<style lang="scss">
  // the main file that imports everything related with styles
  @use '/src/scss/settings.scss';
</style>
